<mb-icon [icon]="offer.icon"></mb-icon><span class="text">{{ offer.name }}</span>